import { Document as LibDocument, Page, View } from "@react-pdf/renderer";
import React from "react";
import { CreateBillDto } from "../model/bill/dto/CreateBillDto";
import { PDFFooter } from "./sections/PDFFooter";
import { PDFHeader } from "./sections/PDFHeader";
import { PDFTable } from "./sections/PDFTable";
import { UpdateBillDto } from "../model/bill/dto/UpdateBillDto";
import { Bill } from "../model/bill/types/Bill";

const pageStyle: any = {
  paddingHorizontal: 20,
  paddingVertical: 10,
};

type PDFDocumentProps = {
  dto: CreateBillDto | UpdateBillDto | Bill;
};

export const PDFDocument: React.FC<PDFDocumentProps> = ({ dto }) => {
  return (
    <LibDocument>
      <Page style={pageStyle} size="A4" orientation="portrait" wrap={false}>
        <View style={style}>
          <PDFHeader dto={dto} />
          <PDFTable dto={dto} />
          <PDFFooter dto={dto} />
        </View>
      </Page>
    </LibDocument>
  );
};

const style: any = {
  fontSize: 12,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: "10px",
};
